<template>
    <main class="main-content collection">
        <collection-router></collection-router>
    </main>
</template>
<script>
    import CollectionRouter from './../components/CollectionRouter'

    export default {
        components: {
            CollectionRouter
        },
        metaInfo() {
            return {
                title: this.$t('seo.collection.title'),
                meta: [
                    {name: 'title', content: this.$t('seo.collection.title')},
                    {name: 'description', content: this.$t('seo.collection.description')}
                ]
            }
        }
    }
</script>